// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eEXIP","questions":"styles_questions__3EH4i","footer":"styles_footer__dpxwo"};